import { $masterAPI } from '../http'

interface IFirebaseTokenResponse {
    token: string
    uid: string
}

interface ILicenseResponse {
    fbrd_token: string
    api_url: string
    licence_name: string
    language: string
}

export const MasterAPI = {
    async fetchFirebaseToken() {
        const { data } = await $masterAPI.get<{ data: IFirebaseTokenResponse }>('fb-token')

        return data.data.token
    },
    async fetchLicense() {
        const { data } = await $masterAPI.get<{ data: ILicenseResponse }>('licence-info')

        return data.data
    },
}
